import React from 'react';

import Ab2 from '../../images/homesection2.webp'
import Ab1 from '../../images/signeture.png'

const aboutS3 = () => {
    return (
        <section className="about_section_s3 pt-0">
            <div className="container">
                <div className="wrapper">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-12 order-2 order-lg-1">
                            <div className="content">
                                <h2>Our Mission</h2>
                                <h3>Reviving Pharmacies, Inspiring Investments</h3>
                                <p>At Pharmacy Freedom Fund, we bridge the gap between passionate investors and independent pharmacies, creating mutually beneficial partnerships that drive growth, improve healthcare delivery, and generate substantial returns.</p>
                                <p>Our approach is built on a foundation of mutual success. We believe in the strength of independent pharmacies and their vital role in community health. By providing the resources, expertise, and support they need, we enable these businesses to flourish.</p>
                                <div className="ceo">
                                    <div>
                                        <h4>Amr Hillal</h4>
                                        <span>General Partner</span>
                                    </div>
                                    <div>
                                        <div
                                            style={{
                                                fontFamily: "'Great Vibes', cursive",
                                                fontSize: "48px",
                                                color: "#2c3e50",
                                                textAlign: "center",
                                                padding: "10px",
                                            }}
                                        >
                                            Amr Hillal
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12 order-1 order-lg-2">
                            <div className="about_left">
                                <img src={Ab2} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default aboutS3;